import React from 'react';
import type { ParsedQuestion } from '../../components/survey/types';
import { UI_TEXT } from '../../config/ui-text';
import { SLIDER_VALUE_PREFIX_MAX_LENGTH } from './SliderScaleInput';

const { LABELS } = UI_TEXT.HUMAN_SURVEY.QUESTIONS_PREVIEW;

interface Props {
  question: ParsedQuestion;
  onChange: (slider: NonNullable<ParsedQuestion['slider']>) => void;
}

/** Text shown before the slider's big number; writes into `slider` without dropping its other keys. */
export const SliderPrefixSetting: React.FC<Props> = ({ question, onChange }) => {
  if (!question.slider) return null;
  const slider = question.slider;
  const inputId = `slider-value-prefix-${question.id}`;

  return (
    <div>
      <label htmlFor={inputId} className="block text-xs text-gray-600 mb-1">
        {LABELS.SLIDER_VALUE_PREFIX}
      </label>
      <input
        type="text"
        id={inputId}
        maxLength={SLIDER_VALUE_PREFIX_MAX_LENGTH}
        placeholder={LABELS.SLIDER_VALUE_PREFIX_PLACEHOLDER}
        value={slider.value_prefix ?? ''}
        onChange={(e) => onChange({ ...slider, value_prefix: e.target.value })}
        className="w-full px-3 py-1 border border-gray-300 rounded text-sm"
      />
    </div>
  );
};
